
import React from "react";
import { Document, Page, Text, View, StyleSheet, Image,Font } from "@react-pdf/renderer";

const parseHtmlContent = (htmlContent) => {
  const div = document.createElement("div");
  div.innerHTML = htmlContent;

  return Array.from(div.childNodes).map((node, index) => {
    if (node.nodeName === "U") {
      // Handle underlined text
      return (
        <Text key={index} style={styles.underlined}>
          {node.textContent}
        </Text>
      );
    }

    if (node.nodeName === "P" && node.innerHTML.includes("<u>")) {
      // Handle paragraphs with underlined content
      return (
        <View key={index}>
          <Text style={styles.underlined}>
            {node.textContent.trim()}
          </Text>
          <View style={{ marginBottom: 10 }} /> {/* Add space after */}
        </View>
      );
    }

    if (node.nodeName === "OL") {
      return (
        <View key={index} style={{ marginBottom: 10 }}>
          {Array.from(node.childNodes).map((li, idx) => (
            <View key={idx} style={styles.listItemContainer}>
              <Text style={styles.listItemNumber}>{`${idx + 1}.`}</Text>
              <Text style={styles.listItemText}>{li.textContent.trim()}</Text>
            </View>
          ))}
        </View>
      );
    }

    if (node.nodeName === "UL") {
      return (
        <View key={index} style={{ marginBottom: 10 }}>
          {Array.from(node.childNodes).map((li, idx) => (
            <View key={idx} style={styles.listItemContainer}>
              <Text style={styles.listItemNumber}>•</Text>
              <Text style={styles.listItemText}>{li.textContent.trim()}</Text>
            </View>
          ))}
        </View>
      );
    }


    return (
      <Text key={index} style={styles.text}>
        {node.textContent.trim()}
      </Text>
    );
  });
};



  
  
  
  
  
const PurchaseOrderPDF = ({ purchaseorder, quotationNotes, purchaseorderTerms, companyDetails }) => {
    console.log("PurchaseOrder Data:", purchaseorder);
 if (!purchaseorder) {
    return <Text>Loading...</Text>; // Handle cases where purchaseorder is null/undefined
  }
    console.log(Font);

    Font.register({
      family: "Arial",
      src: "http://localhost:3000/fonts/arial/arial.ttf",
    });
    
    console.log("Registered Fonts:", Font.getRegisteredFontFamilies());


  return (
    <Document>
      <Page style={styles.page}>
        {/* Header Section */}
        <View style={styles.header}>
          <View>
            <Text style={styles.companyName}>{companyDetails.company_name ||'Systech Technologies'}</Text>{"\n"}
            <Text style={styles.companyDetails}>
              {companyDetails.phone} <br />{"\n"}
              {companyDetails.email} <br />{"\n"}
              <Text>Dar Al Nahda Building, Office 307{"\n"}P.O Box 91607</Text>{"\n"}
            </Text>
          </View>
          <View style={styles.topRight}>
            <Image
              src="/images/655c8bbb23be8.png" // Provide the image source
              style={styles.image}
            />
            <Text style={styles.purchaseorderTitle}>PurchaseOrder</Text>
          </View>
        </View>

   
<View style={styles.detailsSection}>
                    <View>
                        <Text>To,</Text>

                        <Text> {purchaseorder.product_item_details[0].product?.vendor?.name }</Text>
                        <Text> {purchaseorder.product_item_details[0].product?.vendor?.mobile }</Text>
                        <Text> {purchaseorder.product_item_details[0].product?.vendor?.email }</Text>
                        <Text> {purchaseorder.product_item_details[0].product?.vendor?.address }</Text>


                    </View>
                    <View>
                        <Text>PO #: {purchaseorder.ref_no || " "}</Text>
                        <Text>Date: {purchaseorder.date || " "}</Text>
                    </View>
                </View>

        {/* Table Section */}
        <View style={styles.table}>
  {/* Table Header */}
  <View style={styles.tableRow}>
    <Text style={[styles.tableHeader, { width: "5%" }]}>No</Text>
    <Text style={[styles.tableHeader, { width: "20%" }]}>Product</Text>
    <Text style={[styles.tableHeader, { width: "40%" }]}>Description</Text>
    <Text style={[styles.tableHeader, { width: "10%" }]}>Qty</Text>
     <Text style={[styles.tableHeader, { width: "10%" }]}>Rate</Text>
    <Text style={[styles.tableHeader, { width: "15%" }]}>Amount</Text>
  </View>

  {/* Table Rows */}
  {purchaseorder?.product_item_details?.length > 0 ? (
    purchaseorder.product_item_details.map((item, index) => (
      <View key={index} style={styles.tableRow}>
        <Text style={[styles.tableCell, { width: "5%" }]}>{index + 1}</Text>
        <Text style={[styles.tableCell, { width: "20%" }]}>
          {item.product?.product_name || ""}
        </Text>
        <Text style={[styles.tableCell, { width: "40%" }]}>
          {item.item_description || ""}
        </Text>
        <Text style={[styles.tableCell, { width: "10%" }]}>
          {item.quantity || ""}
        </Text>
        <Text style={[styles.tableCell, { width: "10%" }]}>
          {item.price || ""}
        </Text>
        
        <Text style={[styles.tableCell, { width: "15%" }]}>
          {(item.subtotal)}
        </Text>
      </View>
    ))
  ) : (
    <Text style={{ textAlign: "center", fontStyle: "italic" }}>
      No items available
    </Text>
  )}
</View>


        {/* Footer Section */}
        <View style={styles.footer}>
          {purchaseorder.discount_amount && purchaseorder.discount_amount > 0 && (
            <Text>
              <Text style={{ fontWeight: "bold" }}>One Time Discount: </Text>
              {purchaseorder.discount_amount || ""}
            </Text>
          )}
          <Text>
            <Text style={{ fontWeight: "bold" }}>Total Amount:</Text> {purchaseorder?.amount || ""}
          </Text>
          {/* <Text>
            <Text style={{ fontWeight: "bold" }}>Advanced Amount (%):</Text> {purchaseorder.advanced_amount || "N/A"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>Balance Amount (%):</Text> {purchaseorder.balance || "N/A"}
          </Text> */}

       
        </View>
        {quotationNotes && (
                    <View style={styles.terms}>
                      {parseHtmlContent(quotationNotes)} {/* Use the notes directly */}
                    </View>
                  )}
        {/* Signature Section */}
        <View style={styles.signfooter}>
          <View style={styles.signatureSection}>
            {["Customer", "Stamp", "Authorized"].map((role, index) => (
              <View key={index} style={styles.signatureBlock}>
                <Text>--------------------------</Text> {/* Placeholder line */}
                <Text>{role}</Text>
                <Text>{role === "Stamp" ? "" : "Signature"}</Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PurchaseOrderPDF;

const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontFamily: "Arial",
      fontSize: 10,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 15,
      borderBottom: ".1px solid #ddd",
    //   paddingBottom: 7,
    },
    companyName: {
      fontSize: 14,
      fontWeight: "bold",
      color: "#415094",
      fontFamily: 'Arial',
    },
    companyDetails: {
      fontSize: 10,
      marginTop: 2,
      color: "#415094",
      lineHeight:1.3
    },
    image: {
        objectFit: "contain",
        marginBottom: "10px",
        maxWidth: "160px",
        maxHeight: "80px",
      },
    purchaseorderTitle: {
      fontSize: 15,
      fontWeight: "bold",
      color: "#415094",
      marginLeft:65,
      lineHeight:.4,
      marginBottom:20,
    },
    detailsSection: {
      flexDirection: "row",
      justifyContent: "space-between",
    //   marginVertical: 10,
    //   borderBottom: "1px solid #ddd",
      paddingBottom: 5,
    lineHeight:1
    },
    column: {
      width: "30%", // Ensure each column takes up half the width with some margin for spacing
    },
    labelValueRow: {
      flexDirection: "row",
      marginBottom: 2, // Space between rows
    },
    label: {
      width: 80, // Fixed width for labels to align data
      fontWeight: "bold",
      fontSize: 10,
      textAlign: "left",
    },
    value: {
      flex: 1, // Allow data to take the remaining space
      fontSize: 10,
      textAlign: "left",
    },
    table: {
        width: "100%",
        marginTop: 10,
        // borderWidth: 1,
        borderColor: "#ddd",
        borderCollapse: "collapse",
      },
      tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#ddd",
        paddingVertical: 5,
      },
      tableHeader: {
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "center",
        // borderRightWidth: 1,
        borderColor: "#ddd",
        padding: 5,
      },
      tableCell: {
        fontSize: 10,
        textAlign: "center",
        // borderRightWidth: 1,
        borderColor: "#ddd",
        padding: 5,
      },
    
    footer: {
      marginTop: 35,
      textAlign: "right",
      fontSize: 10,
      lineHeight:1.8,
      fontWeight:"bold"
    },
    terms: {
        fontSize: 12,
        marginTop: 35,
        textAlign: "left",
        marginBottom: 80,
        // padding:5 ,10

    
      },
      // termsListItem: {
      //   fontSize: 9,  // Adjust the font size as necessary
      //   marginTop: 5,  // Adjust spacing between items if necessary
      //   textAlign: "left",  // Ensure text is left-aligned
      //   lineHeight: 1.5,  // Adjust line height for readability
      // },
      
      // underlined: {
      //   textDecoration: "underline",
      // },
      underlined: {
        textDecoration: "underline", // Ensures the text is underlined
        fontSize: 12,
        fontWeight: "bold", // Optional, if you want bold underlined text
        marginBottom: 5,
      },
      listItem: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: "left",
        lineHeight: 1.5,
      },
      text: {
        fontSize: 10,
        marginBottom: 10,
        lineHeight: 1.5,
      },
      listItemContainer: {
        flexDirection: "row",
        alignItems: "flex-start",
        marginBottom: 5, // Space between list items
      },
      listItemNumber: {
        width: 15, // Adjust the width to control number alignment
        textAlign: "right",
        marginRight: 5, // Space between the number and the text
        fontSize: 10,
      },
      listItemText: {
        flex: 1, // Ensures the text wraps correctly
        fontSize: 10,
        textAlign: "left",
        lineHeight: 1.5, // Adjust line spacing for readability
      },
    signatureSection: {
      flexDirection: "row",
      justifyContent: "space-around",
      marginTop: 80,
    },
    signatureBlock: {
      alignItems: "center",
    },
    signatureLine: {
      width: "100%",
      borderBottom: "1px solid #000",
      marginBottom: 5,
    },
  });
  